import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../../localization/react'
import { MatchCompetitionType } from '../../../Match.types'
import { competitionTypeDescriptionTranslation, competitionTypeTranslation } from '../MatchSettings.constants'

interface Props {
  competitionType: MatchCompetitionType
}

const CompetitionTypeContent = ({ competitionType }: Props) => {
  return (
    <Stack gap={0.5} p={3} width="100%">
      <Text variant="badge">
        <Localized id={competitionTypeTranslation[competitionType]} />
      </Text>
      <Text variant="xsmall">
        <Localized id={competitionTypeDescriptionTranslation[competitionType]} />
      </Text>
    </Stack>
  )
}

export default CompetitionTypeContent
